import { __generator } from "tslib";
import { takeLatest, call, select } from 'redux-saga/effects';
import { findPastedDeviation } from './actionCreators';
import { request } from '../../../xhr';
import { getPrimaryTier, isDeviationAuthor, } from '../../../DeviationViews/_helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        var deviations = require('@wix/da-sample-data').deviationsByType.image;
        return deviations[Math.round(Math.random() * (deviations.length - 1))];
    }
}
function fetchDeviation(deviationLookup) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: "/deviation/fetch",
                    params: {
                        deviationid: deviationLookup.id,
                        type: deviationLookup.type,
                        username: deviationLookup.username,
                    },
                }, fakeResponse)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doFindDeviation(action) {
    var _a, deviationLookup, setEntityData, currentUser, deviationResult, isInTier, isOwner, isPremium, isForbidden;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, deviationLookup = _a.deviationLookup, setEntityData = _a.setEntityData;
                return [4 /*yield*/, select(getCurrentUser)];
            case 1:
                currentUser = _b.sent();
                return [4 /*yield*/, call(fetchDeviation, deviationLookup)];
            case 2:
                deviationResult = _b.sent();
                if (deviationResult && !deviationResult.error) {
                    isInTier = getPrimaryTier(deviationResult);
                    isOwner = isDeviationAuthor(deviationResult, currentUser);
                    isPremium = normalizePremiumFolderData(deviationResult.premiumFolderData).isPremium;
                    isForbidden = isPremium || (isInTier && !isOwner);
                    if (!isForbidden) {
                        return [2 /*return*/, setEntityData(deviationResult)];
                    }
                }
                setEntityData(undefined);
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(findPastedDeviation, doFindDeviation)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map